import { render, staticRenderFns } from "./ask_question.vue?vue&type=template&id=29a3ca4e&scoped=true"
import script from "./ask_question.vue?vue&type=script&lang=js"
export * from "./ask_question.vue?vue&type=script&lang=js"
import style0 from "./ask_question.vue?vue&type=style&index=0&id=29a3ca4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a3ca4e",
  null
  
)

export default component.exports